import { useQuery } from '@tanstack/react-query'
import { getAsync } from '@/helpers/http-request'

type ExternalProvider = {
  scheme: string
  displayName: string
}

const useExternalProviders = () => {
  const query = useQuery<ExternalProvider[]>({
    queryKey: ['external-providers'],
    queryFn: async () => {
      const response = await getAsync('/signIn/external/providers')
      if (!response.ok) return []
      return response.json()
    },
    staleTime: Infinity,
  })

  return {
    providers: query.data ?? [],
    isLoading: query.isLoading,
  }
}

export default useExternalProviders
